import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import axios from "axios";

const API_BASE = "https://alkebulanfkalertbackend.onrender.com/api/chat";
const socket = io("https://alkebulanfkalertbackend.onrender.com", {
  transports: ["websocket"],
});

const AdminChat = () => {
  const [users, setUsers] = useState([]);
  const [activeUser, setActiveUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState("");

  // ✅ Fetch users
 const fetchUsers = async () => {
  try {
    const token = localStorage.getItem("token");
    const { data } = await axios.get(`${API_BASE}/admin/users`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log("Fetched users:", data);
    setUsers(data);
  } catch (err) {
    if (err.response) {
      console.error("Backend error:", err.response.status, err.response.data);
    } else {
      console.error("Error fetching users:", err);
    }
  }
};


  // ✅ Fetch messages for a user
  const fetchMessages = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${API_BASE}/admin/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessages(data);
    } catch (err) {
      console.error("Error fetching messages:", err);
    }
  };

  // ✅ Send message
  const sendMessage = async () => {
    if (!newMsg.trim() || !activeUser) return;
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(
        `${API_BASE}/admin/${activeUser}`,
        { message: newMsg },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages((prev) => [...prev, data]);
      setNewMsg("");
    } catch (err) {
      console.error("Error sending message:", err);
    }
  };

  // ✅ Socket listeners
  useEffect(() => {
    socket.emit("registerAdmin");

    socket.on("userMessage", ({ userId, message, sender, createdAt }) => {
      // Update active chat
      if (userId === activeUser) {
        setMessages((prev) => [
          ...prev,
          { userId, message, sender, createdAt },
        ]);
      }
      fetchUsers(); // update latest message preview
    });

    socket.on("adminSent", ({ userId, message, createdAt }) => {
      if (userId === activeUser) {
        setMessages((prev) => [
          ...prev,
          { userId, message, sender: "admin", createdAt },
        ]);
      }
      fetchUsers();
    });

    fetchUsers();

    return () => {
      socket.off("userMessage");
      socket.off("adminSent");
    };
  }, [activeUser]);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar: users */}
      <div className="w-1/4 bg-white border-r p-4 overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">Users</h2>
        {users.map((u) => (
          <div
            key={u.userId}
            className={`p-2 rounded cursor-pointer mb-2 ${
              activeUser === u.userId ? "bg-blue-100" : "hover:bg-gray-200"
            }`}
            onClick={() => {
              setActiveUser(u.userId);
              fetchMessages(u.userId);
            }}
          >
            <p className="font-semibold">User: {u.userId}</p>
            <p className="text-sm text-gray-600 truncate">
              {u.lastSender}: {u.lastMessage}
            </p>
          </div>
        ))}
      </div>

      {/* Chat window */}
      <div className="flex-1 flex flex-col">
        {activeUser ? (
          <>
            <div className="flex-1 p-4 overflow-y-auto">
              {messages.map((msg, i) => (
                <div
                  key={i}
                  className={`mb-2 flex ${
                    msg.sender === "admin" ? "justify-end" : "justify-start"
                  }`}
                >
                  <div
                    className={`px-4 py-2 rounded-lg max-w-xs ${
                      msg.sender === "admin"
                        ? "bg-blue-500 text-white"
                        : "bg-gray-300 text-black"
                    }`}
                  >
                    {msg.message}
                  </div>
                </div>
              ))}
            </div>

            <div className="p-4 border-t flex">
              <input
                value={newMsg}
                onChange={(e) => setNewMsg(e.target.value)}
                className="flex-1 border rounded-lg px-3 py-2"
                placeholder="Type a message..."
              />
              <button
                onClick={sendMessage}
                className="ml-2 px-4 py-2 bg-blue-600 text-white rounded-lg"
              >
                Send
              </button>
            </div>
          </>
        ) : (
          <div className="flex-1 flex items-center justify-center text-gray-500">
            Select a user to start chatting
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminChat;

